import { getItem } from "./cooke-data";

export default function getUserDetail() {
  return getItem("user");
}
